import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { User } from '../../types';
import { authApi } from '../../features/auth/authApi';

interface AuthState {
  user: User | null;
  isAuthenticated: boolean;
  error: string | null;
}

const stored = sessionStorage.getItem('hrms_user');
const initialState: AuthState = {
  user: stored ? JSON.parse(stored) : null,
  isAuthenticated: !!stored,
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginSuccess(state, action: PayloadAction<User>) {
      state.user = action.payload;
      state.isAuthenticated = true;
      state.error = null;
      sessionStorage.setItem('hrms_user', JSON.stringify(action.payload));
    },
    logout(state) {
      state.user = null;
      state.isAuthenticated = false;
      state.error = null;
      sessionStorage.removeItem('hrms_user');
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      authApi.endpoints.loginUser.matchFulfilled,
      (state, { payload }) => {
        const user = payload.user || payload;
        const token = payload.token;
        const userWithToken = token ? { ...user, token } : user;
        state.user = userWithToken;
        state.isAuthenticated = true;
        sessionStorage.setItem('hrms_user', JSON.stringify(userWithToken));
      }
    );
  },
});

export const { loginSuccess, logout } = authSlice.actions;
export default authSlice.reducer;
